module.exports = __webpack_public_path__ + "img/eth-gold-exports-chart.c997ae0a.svg";